import React, { Fragment } from "react";
import { Card, Row, Col, Button } from 'react-bootstrap';
import '../../../../../../styles/diario.scss';

const Concurso = (props) => {


    const deletar = async (id) => {
        props.deletar(id)
        await props.fetchConcursos()
    }

    const editar = async (id) => {
        props.editar(id)
    }
    return (
        <Fragment>
            <Col>
                <Card className='card-list'>
                    <Card.Header><h5>{props.conc.referencia ? <span>Edital de Convocação nº {props.conc.referencia}</span> : <span>Edital de Abertura do Concurso</span>} de {props.conc.anexos[0].ano ? props.conc.anexos[0].ano : props.conc.ano}</h5></Card.Header>
                    <Card.Body>
                        <p>{props.conc.orgao}</p>
                    </Card.Body>
                    <hr />
                    <Button type="button" className="botao-leis" onClick={() => editar(props.conc._id)} variant='primary'>Editar</Button>
                    <Button type='button' className="botao-leis" onClick={() => deletar(props.conc._id)} variant='danger'>Excluir</Button>
                </Card>
            </Col>
        </Fragment >)
}

export default Concurso;